interface IconButtonProps {
  icon: string;
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  disabled?: boolean;
  loading?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export default function IconButton({
  icon,
  onClick,
  className,
  size = 'md',
  iconClassName,
  disabled,
  loading,
}: IconButtonProps) {
  const disableBtn = disabled || loading;
  const iconSize =
    size === 'xs' ? 'h-4 w-4' : size === 'sm' ? 'h-5 w-5' : size === 'md' ? 'h-6 w-6' : 'h-8 w-8';
  return (
    <button
      type="button"
      disabled={disableBtn}
      className={`aspect-square p-0.5 rounded-full bg-transparent text-ds-text-tertiary hover:text-ds-text-secondary focus:outline-none focus:ring-1 focus:ring-primary/30 cursor-pointer disabled:cursor-not-allowed ${className}`}
      onClick={() => {
        if (!disableBtn) {
          // Create a reference to the button element
          const button = document.activeElement;
          // Remove focus after 2 seconds
          setTimeout(() => {
            if (button instanceof HTMLElement) {
              button.blur();
            }
          }, 50);
          if (onClick) onClick();
        }
      }}
    >
      <span className="sr-only">Close</span>
      <img
        src={icon}
        alt=""
        className={`text-black ${iconClassName ? iconClassName : iconSize}`}
        aria-hidden="true"
      />
    </button>
  );
}
